import { render, staticRenderFns } from "./Calc.vue?vue&type=template&id=6615b845&scoped=true&"
import script from "./Calc.vue?vue&type=script&lang=js&"
export * from "./Calc.vue?vue&type=script&lang=js&"
import style0 from "./Calc.vue?vue&type=style&index=0&id=6615b845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6615b845",
  null
  
)

export default component.exports